import React, { useEffect, useRef, useState } from "react";
import "./Avatar.less";

interface AvatarProps {
   children?: React.ReactNode;
   icon?: React.ReactNode;
   src?: string;
   alt?: string;
   style?: React.CSSProperties;
   className?: string;
   size?: string | number;
   shape?: string;
}

export const Avatar: React.FC<AvatarProps> = ({
   children,
   icon,
   style,
   className,
   size = "default",
   shape,
   src,
   alt = ""
}) => {
   const styles = Number.isFinite(size) && {
      ...style,
      width: size + "px",
      height: size + "px",
      fontSize: +size / 2 + "px"
   };

   const avatarRef = useRef<HTMLDivElement>(null);
   const stringRef = useRef<HTMLSpanElement>(null);
   const [isError, setIsError] = useState(false);

   // here we adjust the text so that it fits into div
   useEffect(() => {
      const avatar = avatarRef.current;
      const text = stringRef.current;
      if (!avatar || !text) return;

      const availableWidth = avatar.offsetWidth - 10;
      const textWidth = text.offsetWidth;
      const scaleFactor = textWidth > availableWidth ? availableWidth / textWidth : 1;

      text.style.transform = `translate(-50%, -50%) scale(${scaleFactor})`;
   }, []);

   return (
      <div
         ref={avatarRef}
         data-testid="bp2-avatar"
         className={`bp2-avatar ${className ? className : ""} ${
            shape === "square" ? "avatar-sq" : ""
         }  ${
            size === "default"
               ? "avatar-df"
               : size === "large"
               ? "avatar-lg"
               : size === "small"
               ? "avatar-sm"
               : ""
         }`}
         style={styles ? styles : style}
      >
         {src ? (
            isError ? (
               ""
            ) : (
               <img src={src} alt={alt} className="avatar-img" onError={() => setIsError(true)} />
            )
         ) : icon ? (
            <span className="avatar-icon">{icon}</span>
         ) : (
            <span className="avatar-string" ref={stringRef}>
               {children}
            </span>
         )}
      </div>
   );
};

export default Avatar;
